import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import AddReferralsLayer from "../../components/Referral/AddReferral";


const AddReferrals = () => {
  return (
    <>
   

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Referrals  </h5><Breadcrumb title="Add Referrals" /></div>


        {/* AddUserLayer */}
        <AddReferralsLayer />


    </>
  );
};

export default AddReferrals;